import { ChatRoomType, FilterType } from "../types/communicationTypes";

export const MAX_FILE_SIZE = 52428800;

export const NON_HUMAN_AUTHOR_NAMES = ['System User', 'Email User'];

export const templatePlaceHolders = [
  '{firstname}',
  '{lastname}',
  '{fullname}',
  '{originatorfirstName}',
  '{originatorLastName}',
  '{originatorSubmissionLink}',
  '{brandName}',
  '{calendlylink}'
]

export const chatRoomTypeFilters = {
  [FilterType.TASKS]: [ChatRoomType.TASKS]
}